import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addIndustry } from "../../redux/slices/registerSlice";
import { useNavigate } from "react-router-dom";
import { googleEvent_LOJ065 } from "../../lib/google-analytics";
import { googleEvent_LOJ197 } from "../../lib/google-analytics-loan-journey-events";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function Industry() {
  const [loading, setLoading] = useState(false);

  const { industry } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();

  const data = [
    "Information Technology (IT)",
    "Healthcare",
    "Education",
    "Automotive",
    "E-commerce",
    "Hospitality",
    "Other",
  ];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);
    const res = await incompleteDetailsUpdate(data, repeatCustomer);

    if (res && res.statusCode === 200) {
      dispatch(addIndustry(data.value));
      if (repeatCustomer) {
        navigate("/confirm-details");
      } else {
        handleStep();
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ197();
  }, []);

  useEffect(() => {
    loading ? handleShowContextualLoader("Please wait...") : handlehideContextualLoader();
  }, [loading]);

  return (
    <>
      <div className="wrapper auto-height">
        <MainHeader
          title="Employment Details"
          showProgress={true}
          percent={53.83}
          backPageName={repeatCustomer ? "/confirm-details" : ""}
        />

        <div className="mb-3">
          <p className="label">Industry</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "industry",
                value: item,
              });

              // Events
              googleEvent_LOJ065(item, item);
            }}
          >
            <SelectOption name={item} checked={industry} />
          </div>
        ))}

        <br />
      </div>

    </>
  );
}
